import { render, staticRenderFns } from "./admin-booking-list.vue?vue&type=template&id=2d3ce32a"
import script from "./admin-booking-list.vue?vue&type=script&lang=js"
export * from "./admin-booking-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports